import { ThemeIcon } from '@mantine/core';
import {
  IconFileDescription,
  IconFileText,
  IconHeadphones,
  IconPhoto,
  IconVideo,
  type IconProps,
} from '@tabler/icons-react';
import { type ComponentType } from 'react';

import { contentTypes } from '../../types';

const ICON_BY_TYPE: Record<contentTypes.ContentType, ComponentType<IconProps>> = {
  text: IconFileText,
  photo: IconPhoto,
  video: IconVideo,
  audio: IconHeadphones,
  document: IconFileDescription,
};

type Props = {
  type: contentTypes.ContentType;
  size?: number;
};

export const TypeIcon = ({ type, size = 32 }: Props) => {
  const Icon = ICON_BY_TYPE[type];
  return (
    <ThemeIcon variant="light" radius="md" size={size}>
      <Icon size={Math.round(size * 0.55)} stroke={1.5} />
    </ThemeIcon>
  );
};
